export const crmScpContactsAccess = 'crm-scp-contacts-access';
export const crmScpContactsBaseAccess = 'crm-scp-contacts-base-access';
export const JOURNEY_ANALYTICS_READ_SCOPE = 'journey-analytics-read';
export const DEAL_JOURNEY_ANALYTICS_READ = 'deal-journey-analytics-read';
export const REPORT_BUILDER_ACCESS_SCOPE = 'custom-reporting-access';